// Home module
SEVEN.Home = angular.module('SEVENHome', []);

SEVEN.Home.controller(
    'SEVENHomeCtrl',
    ['$state', '$scope', 'SEVENAdWords', 'SEVENConfig', 'SEVENMenus', 'SEVENUser', 'SEVENSettings', function ($state, $scope, SEVENAdWords, SEVENConfig, SEVENMenus, SEVENUser, SEVENSettings) {
        var menus = SEVENMenus,
            adWords = SEVENAdWords,
            config = SEVENConfig,
            user = SEVENUser,
            settings = SEVENSettings,
            vm = this;

        var triggerConversion = function () {
            adWords.conversion('home');
        };

        var init = function () {
            vm.products = createProductItems();
            vm.exclusionOverlayChipText = config.messages.player.selfExcluded;
            vm.user = user;
            vm.greyscaleProducts = $state.current.data && $state.current.data.greyscaleProducts;
            vm.isCustomUrl = settings.useCustomImages;

            $scope.$emit('SEVEN.StateLoading', false);

            triggerConversion();
            setProfileChangeListener();
        };

        var createProductItems = function () {
            angular.forEach(menus.home_products, function (item) {
                item.titles = splitTitle(item.title);
                item.excluded = isExcluded(item);
            });

            return menus.home_products;
        };

        var splitTitle = function (title) {
            var titles = [],
                titleSpliter = ' ';

            if (title.indexOf(titleSpliter) > -1) {
                var titleParts = title.split(titleSpliter);
                titles.push(titleParts[0]);
                titleParts.shift();
                if (titleParts.length) {
                    titles.push(
                        titleParts.reduce(function (a, b) {
                            return a + titleSpliter + b;
                        })
                    );
                }
            } else {
                titles.push(title);
            }

            return titles;
        };

        var setProfileChangeListener = function () {
            // Set exclusions when user does login
            $scope.$on('SEVEN.PlayerProfileChange', setProductExclusions);
            // Logout doesn't broadcast SEVEN.PlayerProfileChange event so this is also required
            $scope.$on('SEVEN.UserLogin', setProductExclusions);
        };

        var setProductExclusions = function () {
            angular.forEach(vm.products, function (item) {
                item.excluded = isExcluded(item);
            });
        };

        var isExcluded = function (item) {
            var productDisplayId =
                item.customData.exclusionProductDisplayId || item.customData.productDisplayId;

            if (user.profile && user.isUISSelfExcluded) {
                return {
                    product: productDisplayId,
                    isExcludedPermanently: user.profile.uisSelfExclusion.isPermanentExcluded,
                    dateTo: user.profile.uisSelfExclusion.excludedUntil,
                };
            }

            var selfExcludedProducts = user.profile && user.profile.selfExcludedProducts;

            return angular.isArray(selfExcludedProducts)
                ? selfExcludedProducts.find(function (excludedProduct) {
                      return excludedProduct.product === productDisplayId;
                  })
                : false;
        };

        init();
    }]
);
